import React from 'react';
import SEOHead from '../../components/feature/SEOHead';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { AboutSection } from './components/AboutSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';

const Home = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const localBusinessJsonLd = {
    "@type": "LocalBusiness",
    "name": "Acquistions Portfolio Developer | Buyback Closings",
    "description": "Acquisitions Portfolio Developer - Buyback Closings mapped out for 80% of all resorts clients own. Expert timeshare exit, resort resales, and deed transfers in Springfield, IL.",
    "url": siteUrl,
    "telephone": "+1-773-850-0086",
    "logo": "https://static.readdy.ai/image/bfd7cfc1238ff10ba7882ad58dadd087/78c2ec49bfaa94f3f96ba42364e68888.png",
    "image": "https://static.readdy.ai/image/bfd7cfc1238ff10ba7882ad58dadd087/78c2ec49bfaa94f3f96ba42364e68888.png",
    "priceRange": "$$",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "2501 Chatham Rd # 6122",
      "addressLocality": "Springfield",
      "addressRegion": "IL",
      "postalCode": "62704",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "39.7817",
      "longitude": "-89.6501"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
        "opens": "10:00",
        "closes": "18:00"
      }
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+1-773-850-0086",
      "contactType": "customer service",
      "availableLanguage": "English",
      "areaServed": "US"
    },
    "areaServed": {
      "@type": "Country",
      "name": "United States"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "127"
    },
    "sameAs": [
      "https://facebook.com/acquisitionsportfolio",
      "https://twitter.com/acquisitionsportfolio",
      "https://linkedin.com/company/acquisitionsportfolio"
    ]
  };

  const serviceJsonLd = {
    "@type": "Service",
    "serviceType": "Timeshare Exit & Buyback Closings",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Acquistions Portfolio Developer | Buyback Closings",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "2501 Chatham Rd # 6122",
        "addressLocality": "Springfield",
        "addressRegion": "IL",
        "postalCode": "62704",
        "addressCountry": "US"
      }
    },
    "areaServed": {
      "@type": "Country",
      "name": "United States"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Timeshare & Resort Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Timeshare Exit Services",
            "description": "Professional assistance with timeshare cancellation and exit strategies tailored to your resort."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Buyback Closings",
            "description": "Our company has mapped out the Buyback Closings strategy for about 80% of all resorts clients own."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Resort Resales",
            "description": "Expert resort property resale and transfer services to maximize your investment value."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Deed Transfers",
            "description": "Legal deed transfer and ownership change services handled by experienced professionals."
          }
        }
      ]
    }
  };

  const websiteJsonLd = {
    "@type": "WebSite",
    "name": "Acquistions Portfolio Developer | Buyback Closings",
    "url": siteUrl,
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${siteUrl}/?s={search_term_string}`,
      "query-input": "required name=search_term_string"
    }
  };

  const webPageJsonLd = {
    "@type": "WebPage",
    "name": "Acquistions Portfolio Developer | Buyback Closings",
    "description": "Acquisitions Portfolio Developer - Buyback Closings mapped out for 80% of all resorts. Timeshare exit, resort resales, and deed transfers. Call 773-850-0086.",
    "url": siteUrl,
    "inLanguage": "en-US",
    "isPartOf": {
      "@type": "WebSite",
      "url": siteUrl
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": siteUrl
        }
      ]
    }
  };

  const faqJsonLd = {
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What are Buyback Closings?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Buyback Closings is a strategy we have mapped out for about 80% of all resorts clients own. It allows clients to exit their timeshare obligations through a structured resort buyback closing process."
        }
      },
      {
        "@type": "Question",
        "name": "What timeshare exit services do you offer?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We offer timeshare exit services, resort resales, deed transfers, and buyback closings. Our team has over a decade of experience helping clients navigate complex property situations."
        }
      },
      {
        "@type": "Question",
        "name": "How can I contact Acquisitions Portfolio Development?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can reach us by phone at 773-850-0086 or visit our office at 2501 Chatham Rd # 6122, Springfield, IL 62704."
        }
      },
      {
        "@type": "Question",
        "name": "What areas do you serve?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We serve clients across the entire United States, helping them with timeshare exits, resort resales, deed transfers, and buyback closings regardless of which resort they own."
        }
      }
    ]
  };

  const reviewsJsonLd = {
    "@type": "ItemList",
    "name": "Client Reviews — Acquisitions Portfolio Developer | Buyback Closings",
    "numberOfItems": 6,
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "item": {
          "@type": "Review",
          "datePublished": "2024-09-15",
          "reviewBody": "Acquisitions Portfolio helped me liquidate my timeshare contract that I had been stuck with for years. Their team was professional, transparent, and delivered exactly what they promised. I finally feel free from that financial burden!",
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5", "worstRating": "1" },
          "author": { "@type": "Person", "name": "Sarah Johnson" },
          "itemReviewed": { "@type": "LocalBusiness", "name": "Acquisitions Portfolio Developer | Buyback Closings" }
        }
      },
      {
        "@type": "ListItem",
        "position": 2,
        "item": {
          "@type": "Review",
          "datePublished": "2024-10-03",
          "reviewBody": "I was amazed at how quickly they sold my resort property. The market analysis was spot-on, and within just 3 months the deal was closed. The entire process was smooth and completely stress-free.",
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5", "worstRating": "1" },
          "author": { "@type": "Person", "name": "Michael Chen" },
          "itemReviewed": { "@type": "LocalBusiness", "name": "Acquisitions Portfolio Developer | Buyback Closings" }
        }
      },
      {
        "@type": "ListItem",
        "position": 3,
        "item": {
          "@type": "Review",
          "datePublished": "2024-11-20",
          "reviewBody": "The deed transfer service was exceptional. They handled all the legal paperwork and made sure everything was compliant. I appreciated their attention to detail and constant communication throughout the process.",
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5", "worstRating": "1" },
          "author": { "@type": "Person", "name": "Emily Rodriguez" },
          "itemReviewed": { "@type": "LocalBusiness", "name": "Acquisitions Portfolio Developer | Buyback Closings" }
        }
      },
      {
        "@type": "ListItem",
        "position": 4,
        "item": {
          "@type": "Review",
          "datePublished": "2025-01-08",
          "reviewBody": "Their buyback closing consultation saved me from making a costly mistake. The team provided valuable insights into market trends and helped me optimize my property portfolio. Highly recommend their expertise!",
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5", "worstRating": "1" },
          "author": { "@type": "Person", "name": "David Thompson" },
          "itemReviewed": { "@type": "LocalBusiness", "name": "Acquisitions Portfolio Developer | Buyback Closings" }
        }
      },
      {
        "@type": "ListItem",
        "position": 5,
        "item": {
          "@type": "Review",
          "datePublished": "2025-02-14",
          "reviewBody": "After years of paying maintenance fees on a timeshare I never used, Acquisitions Portfolio got me out in under 90 days. Their buyback closings process was clear and straightforward from start to finish.",
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5", "worstRating": "1" },
          "author": { "@type": "Person", "name": "Linda Marsh" },
          "itemReviewed": { "@type": "LocalBusiness", "name": "Acquisitions Portfolio Developer | Buyback Closings" }
        }
      },
      {
        "@type": "ListItem",
        "position": 6,
        "item": {
          "@type": "Review",
          "datePublished": "2025-03-01",
          "reviewBody": "The team walked me through every step of the buyback closing process. No hidden fees, no surprises — just results. I would absolutely recommend them to anyone looking to exit their timeshare.",
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5", "worstRating": "1" },
          "author": { "@type": "Person", "name": "James Okafor" },
          "itemReviewed": { "@type": "LocalBusiness", "name": "Acquisitions Portfolio Developer | Buyback Closings" }
        }
      }
    ]
  };

  const organizationJsonLd = {
    "@type": "Organization",
    "name": "Acquisitions Portfolio Developer",
    "alternateName": "Buyback Closings",
    "url": siteUrl,
    "logo": {
      "@type": "ImageObject",
      "url": "https://static.readdy.ai/image/bfd7cfc1238ff10ba7882ad58dadd087/78c2ec49bfaa94f3f96ba42364e68888.png",
      "width": 512,
      "height": 512
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+1-773-850-0086",
        "contactType": "customer service",
        "email": "info@acquisitionsportfolio.com",
        "availableLanguage": "English",
        "areaServed": "US",
        "hoursAvailable": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
          "opens": "10:00",
          "closes": "18:00"
        }
      }
    ],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "2501 Chatham Rd # 6122",
      "addressLocality": "Springfield",
      "addressRegion": "IL",
      "postalCode": "62704",
      "addressCountry": "US"
    },
    "sameAs": [
      "https://facebook.com/acquisitionsportfolio",
      "https://twitter.com/acquisitionsportfolio",
      "https://linkedin.com/company/acquisitionsportfolio"
    ]
  };

  const breadcrumbJsonLd = {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": siteUrl
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Services",
        "item": `${siteUrl}/#services`
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "About",
        "item": `${siteUrl}/#about`
      },
      {
        "@type": "ListItem",
        "position": 4,
        "name": "Testimonials",
        "item": `${siteUrl}/#testimonials`
      },
      {
        "@type": "ListItem",
        "position": 5,
        "name": "Contact",
        "item": `${siteUrl}/#contact`
      }
    ]
  };

  const professionalServiceJsonLd = {
    "@type": "ProfessionalService",
    "name": "Acquisitions Portfolio Developer | Buyback Closings",
    "description": "Buyback Closings mapped out for 80% of all resorts clients own. Timeshare exit, resort resales, and deed transfers.",
    "url": siteUrl,
    "telephone": "+1-773-850-0086",
    "email": "info@acquisitionsportfolio.com",
    "priceRange": "$$",
    "currenciesAccepted": "USD",
    "paymentAccepted": "Cash, Credit Card, Check",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "2501 Chatham Rd # 6122",
      "addressLocality": "Springfield",
      "addressRegion": "IL",
      "postalCode": "62704",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "39.7817",
      "longitude": "-89.6501"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
        "opens": "10:00",
        "closes": "18:00"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "127"
    }
  };

  const combinedJsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      localBusinessJsonLd,
      serviceJsonLd,
      websiteJsonLd,
      webPageJsonLd,
      faqJsonLd,
      reviewsJsonLd,
      organizationJsonLd,
      breadcrumbJsonLd,
      professionalServiceJsonLd
    ]
  };

  return (
    <>
      <SEOHead
        title="Acquistions Portfolio Developer | Buyback Closings"
        description="Acquisitions Portfolio Developer - Buyback Closings mapped out for 80% of all resorts clients own. Expert timeshare exit, resort resales, and deed transfers in Springfield, IL. Call 773-850-0086."
        keywords="timeshare exit, buyback closings, resort resale, deed transfer, timeshare cancellation, vacation ownership exit, Springfield IL"
        canonical={siteUrl}
        ogTitle="Acquistions Portfolio Developer | Buyback Closings"
        ogDescription="Acquisitions Portfolio Developer - Buyback Closings mapped out for 80% of all resorts clients own. Expert timeshare exit, resort resales, and deed transfers in Springfield, IL. Call 773-850-0086."
        ogUrl={siteUrl}
        ogImage="https://static.readdy.ai/image/bfd7cfc1238ff10ba7882ad58dadd087/78c2ec49bfaa94f3f96ba42364e68888.png"
        twitterTitle="Acquistions Portfolio Developer | Buyback Closings"
        twitterDescription="Acquisitions Portfolio Developer - Buyback Closings mapped out for 80% of all resorts clients own. Expert timeshare exit, resort resales, and deed transfers in Springfield, IL. Call 773-850-0086."
        twitterImage="https://static.readdy.ai/image/bfd7cfc1238ff10ba7882ad58dadd087/78c2ec49bfaa94f3f96ba42364e68888.png"
        jsonLd={combinedJsonLd}
      />
      <div className="min-h-screen">
        <Header />
        <main>
          <HeroSection />
          <ServicesSection />
          <AboutSection />
          <TestimonialsSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Home;
